/**
 * Customer Vault Page — Route wrapper for CustomerVault component
 */

import { CustomerVault } from '../components/customer/CustomerVault';
import { T } from '../styles/tokens';

export function CustomerVaultPage() {
  return (
    <div>
      <CustomerVault />
    </div>
  );
}
